/* Parent class will hold state, if necessary */
import React from 'react';
import { Field } from "redux-form";

import { PUBLIC } from "../../constants/Game";

export const PublicPrivateChoice = ( props ) => {

    const { onChange, isPublic } = props;
    const publicExplanation = "A public hunt, once you publish it, will be visible and available to everyone.  Please make sure that all "
        + "clues are accessible to the public, that your content is inoffensive and family-friendly, and, "
        + "finally, thank you for contributing to Our Treasure Hunt!";
    const privateExplanation = "Private hunts are only visible and available to users who have a unique access code generated for you "
        + "for this game.  Have fun!";
    const visibilityExplanation = isPublic ? publicExplanation : privateExplanation;

    return (
        <div className="form-group row">
            <label htmlFor="isPublic" className="col-sm-2 col-form-label">Visibility </label>
            <div className="col-sm-8">
                <div>
                    <Field
                        name={PUBLIC}
                        component="input"
                        type="radio"
                        checked={isPublic}
                        onChange={onChange}
                        value="public"
                    />
                    <label className="left-margin" htmlFor={PUBLIC}>
                        Public
                    </label>
                </div>
                <div>
                    <Field
                        name={PUBLIC}
                        component="input"
                        type="radio"
                        checked={! isPublic}
                        onChange={onChange}
                        value="private"
                    />
                    <label className="left-margin" htmlFor={PUBLIC}>
                        Private
                    </label>
                </div>
                <p className="secondary-text">{visibilityExplanation}</p>
            </div>
        </div>
    )
};



// WEBPACK FOOTER //
// ./src/components/huntcomponents/PublicPrivateChoice.js